import { FETCHURI } from '../const/fetchuri';

const getTelemetryApiInstance = async (endPoint: string) => {

    const encodedValue = encodeURIComponent(endPoint);
    let strUrl = FETCHURI.GetRequestAsync + encodedValue;
    return ExecuteTelemetryApiRequest('get', strUrl, '');
}

const postTelemetryApiInstance = async (endPoint: string, data: any) => {
    let strUrl = FETCHURI.PostExecuteRequest;
    return ExecuteTelemetryApiRequest('post', strUrl, data, endPoint);
}

const deleteTelemetryApiInstance = async (endPoint: string, data: any) => {
    let strUrl = FETCHURI.DeleteExecuteRequest;
    return ExecuteTelemetryApiRequest('delete', strUrl, data, endPoint);
}

const postFormTelemetryApiInstance = async (endPoint: string, data: any) => {
    let strUrl = FETCHURI.PostExecuteFormRequest;
    return ExecuteTelemetryApiFormRequest('post', strUrl, data);
}

const ExecuteTelemetryApiRequest = async (method: any, url: any, params: any,endPoint?:any) => {
    type TelemetryOptions = {
        method: string;
        headers: {};
        body?: string;
    };
    const fetchTelemetryOptions: TelemetryOptions = {
        method: method,
        headers:
        {
            'Api-Type': "Telemetry",
            'Content-Type': 'application/json'
        }
    };
    if (method.toString().toLowerCase() != 'get') {
        fetchTelemetryOptions.body = JSON.stringify({
            Param: params,
            Endpoint: endPoint
        })
    }
    return await new Promise((onSucess, onFailure) => {
        fetch(url, fetchTelemetryOptions).then(async (response) => await response.json())
            .then(async (responseJson) => {
                if (responseJson?.result != undefined || responseJson?.result != null) {
                    (responseJson?.result == '') ? onSucess(responseJson?.result) : onSucess(JSON.parse(responseJson?.result));
                }
                else {
                    (responseJson?.statusCode != undefined && responseJson?.statusCode != null && responseJson?.statusCode !== 200) ? onFailure(responseJson.reasonPhrase) : onSucess(responseJson);
                }
            })
            .catch((error) => {
                onFailure(error);
            });
    });
}


const ExecuteTelemetryApiFormRequest = async (method: any, url: any, data: any) => {
    type TelemetryOptions = {
        method: string;
        headers: {};
        body?: string;
    };
    const fetchTelemetryOptions: TelemetryOptions = {
        method: method,
        headers:
        {
            'Api-Type': "Telemetry",
        }
    };
    if (method.toString().toLowerCase() != 'get') {
        fetchTelemetryOptions.body = data
    }
    return await new Promise((onSucess, onFailure) => {
        fetch(url, fetchTelemetryOptions).then(async (response) => await response.json())
            .then(async (responseJson) => {
                if (responseJson?.result != undefined || responseJson?.result != null) {
                    (responseJson?.result == '') ? onSucess(responseJson?.result) : onSucess(JSON.parse(responseJson?.result));
                }
                else {
                    (responseJson?.statusCode != undefined && responseJson?.statusCode != null && responseJson?.statusCode !== 200) ? onFailure(responseJson.reasonPhrase) : onSucess(responseJson);
                }
            })
            .catch((error) => {
                onFailure(error);
            });
    });
}


export { getTelemetryApiInstance, postTelemetryApiInstance, postFormTelemetryApiInstance, deleteTelemetryApiInstance }